import { toast } from "sonner";
import { updateClientContext } from "./api";
import { useMutation } from "@tanstack/react-query";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  const payload = {
    industry_v1: values.sub_industry,
    client_requirement: values.client_requirement,
    nda_level: values.nda_level,
  };

  return payload;
}

export function useClientContextDetails() {
  return useMutation({
    mutationFn: async ({ caseStudyId, values }) => {
      const payload = buildPayload(values);

      const response = await updateClientContext({
        caseStudyId,
        item: payload,
      });
      return response;
    },
    onSuccess: () => {
      invalidateAllQueries();
      toast.success("Client Context Updated Successfully");
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
